var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossRedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E08DBAE2-8B41-4A8D-8D6B-9D13575EED64") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Client-|-Upload-Chart-Failed",
    transform: "translate(-1271.000000, -674.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Progress",
    transform: "translate(582.000000, 674.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(689.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F9480F",
    cx: 19,
    cy: 19,
    r: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.000000, 13.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.333333333,
    y1: 0.352941176,
    x2: 11.6666667,
    y2: 11.6470588,
    id: "Line-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.333333333,
    y1: 0.352941176,
    x2: 11.6666667,
    y2: 11.6470588,
    id: "Line-3",
    transform: "translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRedIcon);
export default __webpack_public_path__ + "static/media/cross-red-icon.3e68ffc48a8a186486feab0352204fd9.svg";
export { ForwardRef as ReactComponent };